<script setup lang="ts" generic="TModel extends Array<any>">
import { useChipGroup } from '~/composables/group';

defineProps<{
  label?: string
}>();

defineSlots<{
  default: () => unknown
}>();

const modelValue = defineModel<TModel>({ required: true });
useChipGroup(modelValue);
</script>

<template>
  <div>
    <IadLabel
      :text="label"
      tag="p"
    />
    <fieldset class="inline-flex gap-xs flex-wrap">
      <slot />
    </fieldset>
  </div>
</template>
